/**
 * @Author: v_jppjpeng
 * @Date: 2023-12-12 19:07:30
 * @Explain: 提示语
 */
import classNames from 'classnames';
import { useMemo } from 'react';
import { AlertProps, Alert as TdAlert } from 'tdesign-react';
import Icon from '../icon';

type PropsType = {
  className?: string;
  style?: AlertProps['style'];
  title?: AlertProps['title'];
  children?: AlertProps['message'];
  message?: AlertProps['message'];
  icon?: AlertProps['icon'];
  hideIcon?: boolean;
  theme?: AlertProps['theme'];
  close?: AlertProps['close'];
  onClose?: AlertProps['onClose'];
};

function Alert(props: PropsType) {
  const iconJson = {
    success: 'solid-circle-check-mark',
    info: 'solid-circle-i',
    warning: 'solid-circle-warning',
    error: 'solid-circle-x',
  };
  const {
    className,
    style,
    children,
    title,
    message,
    icon,
    hideIcon,
    theme,
    close,
    onClose,
  } = props;

  const customProps: AlertProps = useMemo(() => {
    return {
      className: classNames(
        {
          'default-td-alert': true,
          'hide-icon': hideIcon,
        },
        className,
      ),
      style,
      title,
      message: children || message,
      icon: theme && <Icon.Font name={iconJson[theme]} />,
      theme,
      close,
      onClose,
    };
  }, [className, style, title, children, message, icon, theme, close, onClose]);
  return <TdAlert {...customProps} />;
}

export default Alert;
